import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  private static readonly ADDRESS_KEY = 'Address';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public get(): Address {
    return this.storage.get(AddressService.ADDRESS_KEY);
  }

  public set(address: Address) {
    this.storage.set(AddressService.ADDRESS_KEY, address);
  }

  public remove() {
    this.storage.remove(AddressService.ADDRESS_KEY);
  }
}

export interface Address {
  city: string;
  country: string;
  houseNr: string;
  street: string;
  zipCode: string;
  addressSupplement: string;
}
